import React from "react";
import UserProfileForm from '../../../forms/user-form/user-profile-form';

const ProfileTab = ({ getUser, loadingUser, reFetch }) => {


  return (
    <>
      <div className="form-container lg">
        <UserProfileForm loadingUser={ loadingUser } reFetch={ reFetch } getUser={ getUser } />
      </div>
    </>
  );
};

export default ProfileTab;